import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { PageType, PageVersionQuery, PageVersionStoreModel, PageVersionUIModel } from '@examdojo/category/v2';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { combineLatest, map, switchMap } from 'rxjs';

@Injectable()
export class PageVersionBrowserListViewService extends AbstractSimpleListViewService<PageVersionUIModel> {
  constructor(private readonly query: PageVersionQuery) {
    super();
  }

  readonly pageType = signal<PageType | null>(null);
  readonly activeId = signal<PageVersionStoreModel['id'] | null>(null);

  private readonly allActiveTabVersions$ = toObservable(this.pageType).pipe(
    switchMap((pageType) => {
      if (!pageType) {
        return this.query.entities$;
      }
      return this.query.getPageVersionsOfType(pageType);
    }),
  );

  readonly data$ = combineLatest([this.allActiveTabVersions$, toObservable(this.activeId)]).pipe(
    map(([pageVersions, activeId]) =>
      pageVersions.map((version) => ({ ...version, isActive: version.id === activeId })),
    ),
  );
  readonly loading$ = this.query.selectLoading();
}
